import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie, X } from "lucide-react";

export const CONSENT_KEY = "loftebarometer_consent";
export const CONSENT_ACCEPTED = "accepted";
export const CONSENT_ESSENTIAL = "essential";

/** Returnér nuværende samtykke (eller null hvis ikke sat). */
export function getConsent() {
    return localStorage.getItem(CONSENT_KEY);
}

export function setConsent(value) {
    localStorage.setItem(CONSENT_KEY, value);
    // Udløs event så andre komponenter (fx Footer) kan reagere
    window.dispatchEvent(new Event("consent-changed"));
}

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const v = getConsent();
        if (!v) setVisible(true);
    }, []);

    // Skjul banner på admin-side — der er ingen tracking dér og banneret
    // overlapper moderationskøens kontroller.
    if (pathname.startsWith("/admin")) return null;
    if (!visible) return null;

    function accept(choice) {
        setConsent(choice);
        setVisible(false);
    }

    return (
        <div
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50"
            data-testid="cookie-banner"
            role="dialog"
            aria-labelledby="cookie-banner-title"
        >
            <div className="bg-royal-deep text-white rounded-2xl shadow-2xl border border-white/10 p-5 grain">
                <div className="flex items-start gap-3 mb-3">
                    <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                        <Cookie className="w-5 h-5" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div
                            id="cookie-banner-title"
                            className="font-serif-dm text-lg text-white leading-tight mb-1"
                        >
                            Vi respekterer dit privatliv
                        </div>
                        <p className="text-sm text-white/80 leading-snug">
                            Vi bruger kun anonymt <em>localStorage</em> — ingen trackere,
                            ingen reklamer, ingen persondata.{" "}
                            <Link
                                to="/cookies"
                                className="underline hover:text-white"
                                data-testid="cookie-banner-learn-more"
                            >
                                Læs mere
                            </Link>
                            .
                        </p>
                    </div>
                    <button
                        onClick={() => accept(CONSENT_ESSENTIAL)}
                        aria-label="Luk"
                        className="p-1 text-white/50 hover:text-white flex-shrink-0"
                        data-testid="cookie-banner-close"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <div className="flex gap-2 mt-4">
                    <button
                        onClick={() => accept(CONSENT_ESSENTIAL)}
                        data-testid="cookie-essential"
                        className="flex-1 px-3 py-2 bg-white/10 hover:bg-white/15 text-white text-sm font-semibold rounded-full border border-white/10 transition-colors"
                    >
                        Kun nødvendige
                    </button>
                    <button
                        onClick={() => accept(CONSENT_ACCEPTED)}
                        data-testid="cookie-accept"
                        className="flex-1 px-3 py-2 bg-white text-royal-deep text-sm font-semibold rounded-full hover:bg-white/90 transition-colors"
                    >
                        Accepter
                    </button>
                </div>
            </div>
        </div>
    );
}
